/**
 * MkDocs Material / Backstage TechDocs layout breakpoints.
 *
 * Material uses a 0.0625em gap between these so desktop `min-width` and mobile
 * `max-width` never both match. See `@backstage/plugin-techdocs` layout rules
 * and `TechDocsReaderPageContent` MOBILE_MEDIA_QUERY.
 */
export const TECHDOCS_DESKTOP_MIN_WIDTH = '76.25em';
export const TECHDOCS_MOBILE_MAX_WIDTH = '76.1875em';

export const TECHDOCS_DESKTOP_MEDIA_QUERY = `screen and (min-width: ${TECHDOCS_DESKTOP_MIN_WIDTH})`;
export const TECHDOCS_MOBILE_MEDIA_QUERY = `screen and (max-width: ${TECHDOCS_MOBILE_MAX_WIDTH})`;
